import React from "react";
import { IconsmindPenIcon } from "modules/icons";
import useStyles from "./styles";

export const EditIcon: React.FC = () => {
  const { classes } = useStyles();

  return <IconsmindPenIcon className={classes.icon} />;
};
